<div class="overLay" [ngClass]="{'visible': settingSlide , 'hidden': !settingSlide}" (click)="onToggleSettingSlide('', false, $event)"></div>
<div class="settingContainer" [ngClass]="{'open': settingSlide, 'closed': !settingSlide}">
    <div class="setting-blocks">
        <ng-container *ngFor="let item of SettingList">
        <div class="setting-block" *ngIf="!item.disabled"
             (click)="onToggleSettingSlide(item.value, false, $event)">
            <div class="setting-block-image">
                <img [src]="'assets/images/common/aesthetics/' + item.iconClass + '.svg'" alt="item.displayLabel" />
            </div>
            <div class="setting-block-name">{{item.displayLabel}}</div>
            <div class="setting-block setting-block-image setting-block-download" *ngIf="item.value == settingOptions.HelpGuide && (moduleName=='snapshot' || moduleName=='customsnapshot' || moduleName=='crosstab' || moduleName=='brandanalysis' || moduleName=='alert') "
                (click)="onToggleSettingSlide(item.value, true, $event); $event">
                <img src="assets/images/settings/download-icon.svg" [alt]="item.displayLabel" />
            </div>
        </div>
        </ng-container>
    </div>
</div>
